import { gql } from '@apollo/client'

export const RESEND_INVITATION = gql`
  mutation ResendInvitation($email: String!) {
    resendUserInvitation(email: $email)
  }
`
